import { render, staticRenderFns } from "./BasicQueryResult.vue?vue&type=template&id=30ea3970&"
import script from "./BasicQueryResult.vue?vue&type=script&lang=js&"
export * from "./BasicQueryResult.vue?vue&type=script&lang=js&"
import style0 from "./BasicQueryResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports